var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12V12Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 9C8.73263 9 8.79708 9.01955 8.8519 9.05618C8.90671 9.0928 8.94944 9.14486 8.97467 9.20577C8.9999 9.26668 9.0065 9.3337 8.99364 9.39836C8.98077 9.46302 8.94903 9.52242 8.90241 9.56904C8.85579 9.61565 8.7964 9.6474 8.73174 9.66026C8.66708 9.67312 8.60006 9.66652 8.53915 9.64129C8.47824 9.61606 8.42618 9.57334 8.38955 9.51852C8.35292 9.46371 8.33337 9.39926 8.33337 9.33333C8.33337 9.24493 8.36849 9.16014 8.43101 9.09763C8.49352 9.03512 8.5783 9 8.66671 9",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9C15.3993 9 15.4637 9.01955 15.5185 9.05618C15.5733 9.0928 15.6161 9.14486 15.6413 9.20577C15.6665 9.26668 15.6731 9.3337 15.6603 9.39836C15.6474 9.46302 15.6157 9.52242 15.569 9.56904C15.5224 9.61565 15.463 9.6474 15.3984 9.66026C15.3337 9.67312 15.2667 9.66652 15.2058 9.64129C15.1449 9.61606 15.0928 9.57334 15.0562 9.51852C15.0195 9.46371 15 9.39926 15 9.33333C15 9.24493 15.0351 9.16014 15.0976 9.09763C15.1601 9.03512 15.2449 9 15.3333 9",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.376 14.6667C16.8795 15.6687 16.113 16.512 15.1628 17.1016C14.2126 17.6913 13.1165 18.0037 11.9983 18.0037C10.88 18.0037 9.78396 17.6913 8.83376 17.1016C7.88356 16.512 7.11699 15.6687 6.62048 14.6667",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.c7a39969bcc10d60e30847d059ba5700.svg";
export { ForwardRef as ReactComponent };